import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';

import { SESSION_EXPIRED_EVENT } from '@/lib/auth-fetch';

export function SessionExpiredBridge() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    const handler = () => {
      queryClient.clear();
      const redirect = encodeURIComponent(`${window.location.pathname}${window.location.search}`);
      void navigate(`/sign-in?redirect=${redirect}`, { replace: true });
    };
    window.addEventListener(SESSION_EXPIRED_EVENT, handler);
    return () => {
      window.removeEventListener(SESSION_EXPIRED_EVENT, handler);
    };
  }, [navigate, queryClient]);

  return null;
}
